import React from "react";

import "./App.css";

import Selection from "./components/Selection";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { House } from "./pages/House";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/house/:id" element={<House />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
